import React from 'react';
import { StyledCriticalBadge, StyledInProgressBadge, StyledNonCriticalBadge, StyledStatusBadgeWrapper, StyledSuccessBadge, StyledWarningBadge } from './StatusBadge.styled';
var createStatusBadge = function createStatusBadge(BadgeStyle) {
  var Badge = function Badge(props) {
    return /*#__PURE__*/React.createElement(StyledStatusBadgeWrapper, {
      title: props.title
    }, /*#__PURE__*/React.createElement(BadgeStyle, null, props.children));
  };
  return Badge;
};
export var CriticalBadge = createStatusBadge(StyledCriticalBadge);
export var InProgressBadge = createStatusBadge(StyledInProgressBadge);
export var RoleLabelBadge = InProgressBadge;
export var NoncriticalBadge = createStatusBadge(StyledNonCriticalBadge);
export var SuccessBadge = createStatusBadge(StyledSuccessBadge);
export var WarningBadge = createStatusBadge(StyledWarningBadge);